import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { makeStyles } from '@material-ui/styles';
import { Grid, Typography } from '@material-ui/core';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles(() => ({
    root: {},
    marginBottom: {
        marginBottom: 20
    },
    divider: {
        marginBottom: 20,
        marginTop: 20
    },
    gridOverflow: {
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        padding: '6px !important'
    }
}));

const ClaimInformation = ({ claimInfo = {
    claimNumber: 'N/A',
    claimDateOfLoss: 'N/A',
    claimDamageReason: 'N/A'
} }) => {
    const classes = useStyles();
    const { t } = useTranslation();
    return (
        <Grid container>
            <Grid item xs={4} className={classes.gridOverflow}>
                <Typography noWrap variant="h5" color="textPrimary">
                    {claimInfo.claimNumber}

                </Typography>
                <Typography variant="body2" color="textSecondary">
                    {t('glassClaim.claim.authorizationNumber')}
                </Typography>
            </Grid>
            <Grid item xs={4} className={classes.gridOverflow}>
                <Typography noWrap variant="h5" color="textPrimary">
                    {claimInfo.claimDateOfLoss ? moment(claimInfo.claimDateOfLoss).format('MM/DD/YYYY') : 'N/A'}
                </Typography>
                <Typography variant="body2" color="textSecondary">
                    {t('glassClaim.claim.claimDate')}
                </Typography>
            </Grid>
            <Grid item xs={4} className={classes.gridOverflow}>
                <Typography noWrap variant="h5" color="textPrimary" align="right">
                    {claimInfo.claimDamageReason}
                </Typography>
                <Typography variant="body2" color="textSecondary" align="right">
                    {t('glassClaim.claim.claimReason')}
                </Typography>
            </Grid>
        </Grid>
    );
};

ClaimInformation.propTypes = {
    claimInfo: PropTypes.shape({
        claimNumber: PropTypes.string,
        claimDateOfLoss: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]),
        claimDamageReason: PropTypes.string
    })
};

export default ClaimInformation;
